/** How an optional feature Volateq enables per customer (pricing, results modification, ...) is offered. */
export enum OptionalFeatureAccess {
  HIDDEN = "hidden",
  /** Enabled for the customer: shown like any other feature, without the admin marker. */
  CUSTOMER = "customer",
  /** Not enabled for the customer: only Volateq admins see it, marked as an admin feature. */
  ADMIN_ONLY = "admin-only",
}

export class OptionalFeatureHelper {
  /**
   * `isAdmin` is false while "Hide super admin" is on, so the admin-only features disappear with the
   * other admin features then, and the admin sees what the customer sees.
   */
  static getAccess(enabledForCustomer: boolean, isAdmin: boolean): OptionalFeatureAccess {
    if (enabledForCustomer) {
      return OptionalFeatureAccess.CUSTOMER;
    }

    return isAdmin ? OptionalFeatureAccess.ADMIN_ONLY : OptionalFeatureAccess.HIDDEN;
  }
}
